$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navbutton").click(function () {
        $(this).toggleClass("active");
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dropdown
    // *
    // *
    $(".js-dropdown-button").click(function () {
        // Toggle the aria-expanded attribute for the current dropdown item
        const $content = $(this).siblings(".js-dropdown-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);
    });

    // close options on mouseleave
    $(".js-dropdown-wrapper").on("mouseleave", function () {
        $(this).find(".js-dropdown-content").attr("aria-expanded", "false");
    });

    // clicking link
    $(".js-tableswitcher-link").click(function () {
        $(this).addClass("active").siblings().removeClass("active");
    });

    // show selected
    $(".js-dropdown-option").on("change", function () {
        var value = $(this).val();

        if ($(this).is(':checked')) {
            $('[data-dropdown-selected-option="' + value + '"]').addClass("active");
        } else {
            $('[data-dropdown-selected-option="' + value + '"]').removeClass("active");
        }
    });

    // remove selected option
    $(".js-dropdown-selected-option").on("click", function () {
        var value = $(this).data("dropdown-selected-option");
        $('.js-dropdown-option[value="' + value + '"]').prop('checked', false).trigger("change");
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * autocomplete
    // *
    // *
    $(".js-autocomplete-input").on("input", function () {
        let value = $(this).val().toLowerCase().trim().normalize('NFD').replace(/\p{Diacritic}/gu, "")
        let hasMatch = false;

        // Erst mal alles ausblenden
        $(".js-autocomplete-items").hide();

        if (value.length >= 2) {
            $(".js-autocomplete-items").each(function () {
                let text = $(this).text().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, "")

                if (text.startsWith(value)) {
                    $(this).show();
                    hasMatch = true;
                }
            });
        }

        // Container nur anzeigen, wenn Treffer und mindestens 2 Zeichen
        if (hasMatch) {
            $(".js-autocomplete").addClass("active");
        } else {
            $(".js-autocomplete").removeClass("active");
        }
    });

    $(".js-autocomplete-items").on("click", function () {
        let value = $(this).text();
        $(".js-autocomplete-input").val(value).trigger("change");
        $(".js-autocomplete").removeClass("active");
        $(".js-autocomplete-form").submit();
    });

    $(".js-autocomplete-items").on("keydown", function (e) {
        if (e.key === "Enter") {
            let value = $(this).text();
            $(".js-autocomplete-input").val(value).trigger("change");
            $(".js-autocomplete").removeClass("active");
            $(".js-autocomplete-form").submit();
        }
    });

    $(".js-autocomplete-form").on("submit", function (e) {
        e.preventDefault();

        var value = $(".js-autocomplete-input").val(),
            searchValue = value.toLowerCase().trim(),
            type = '';

        $(".js-search-message").hide();
        $(".js-search-title").html(value);

        // Arrays aus den data-Attributen holen
        let listYes = JSON.parse($(".js-autocomplete-form").attr("data-list"));
        let listNo = JSON.parse($(".js-autocomplete-form").attr("data-list-not"));

        if (searchValue.length === 0) return;

        // prüfen ob Treffer vorhanden (Case-insensitive)
        let inYes = listYes.some(item => item.toLowerCase() === searchValue);
        let inNo = listNo.some(item => item.toLowerCase() === searchValue);

        if (inYes) {
            type = 'success';
        } else if (inNo) {
            type = 'danger';
        } else {
            type = 'warning';
        }

        $(`.js-search-message-${type}`).show();
    });

    // close autocomplete on mouseleave
    $(".js-autocomplete-form").on("mouseleave", function () {
        $(".js-autocomplete").removeClass("active");
    });






    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add na class to empty cells / not defined cells
    // *
    // *
    $(".js-card-title").each(function () {
        if ($(this).text().trim() === "NA") {
            $(this).addClass("is-na");
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * gene filter
    // *
    // *
    $(".js-dropdown-option").on("change", function () {
        var value = $(this).val(),
            filter = $(this).data("filter");

        if (filter != 'gene') return;

        // show all
        $(".js-tableswitcher-item.active .js-table-row").removeClass("disabled");

        var selectedFilters = $('[data-filter="gene"]:checked').map(function () {
            var value = $(this).val();

            $(`.js-filter-${filter}-${value}`).addClass("disabled");
        }).get();
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * samsrisk filter
    // *
    // *
    $(".js-dropdown-option").on("change", function () {
        var filter = $(this).data("filter");

        if (filter != 'samsrisk') return;

        // hide all
        $(".js-tableswitcher-item.active .js-table-row").addClass("disabled");

        var selectedFilters = $('[data-filter="samsrisk"]:checked').map(function () {
            var value = $(this).val();

            $(`.js-filter-${filter}-${value}`).removeClass("disabled");

            return value;
        }).get();

        if (selectedFilters.length <= 0) {
            $(".js-tableswitcher-item.active .js-table-row").removeClass("disabled");
        }
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * inhibitor filter
    // *
    // *
    $(".js-dropdown-option").on("change", function () {
        var filter = $(this).data("filter");

        if (filter != 'inhibitor') return;

        // hide all
        $(".js-tableswitcher-item.active .js-table-row").addClass("disabled");

        // show depending on filter
        var selectedFilters = $('[data-filter="inhibitor"]:checked').map(function () {
            var value = $(this).val();

            if (value == 13) $(".table__column:nth-child(1) .js-filter-gene-7").removeClass("disabled");
            if (value == 14) $(".table__column:nth-child(2) .js-filter-gene-7").removeClass("disabled");
            if (value == 15) $(".table__column:nth-child(3) .js-filter-gene-7").removeClass("disabled");
            if (value == 16) $(".table__column:nth-child(4) .js-filter-gene-7").removeClass("disabled");
            if (value == 17) $(".table__column:nth-child(1) .js-filter-gene-2").removeClass("disabled");
            if (value == 18) $(".table__column:nth-child(2) .js-filter-gene-2").removeClass("disabled");
            if (value == 19) $(".table__column:nth-child(3) .js-filter-gene-2").removeClass("disabled");

            return value;
        }).get();

        if (selectedFilters.length <= 0) {
            $(".js-tableswitcher-item.active .js-table-row").removeClass("disabled");
        }

    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * language switcher
    // *
    // *
    $(".js-header-language-button").click(function () {
        const $content = $(this).siblings(".js-header-language-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);
    })

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * headline link 
    // *
    // *
    $('[data-jumpto]').on('click keydown', function (e) {
        // Check if it's a click or Enter key (key code 13)
        if (e.type === 'click' || e.which === 13 || e.keyCode === 13) {
            e.preventDefault(); // Prevent default action

            var targetId = $(this).data('jumpto'); // Get the target ID from data attribute

            $('html, body').scrollTop($(targetId).offset().top);
        }
    });


    $(".badge").click(function () {
        var $element = $(this).parents(".js-table-wrapper");
        var elementPosition = $element.offset().top; // Get the top position of the element
        var elementHeight = $element.outerHeight(); // Get the height of the element
        window.scrollTo({
            top: elementPosition + elementHeight,
            behavior: 'smooth'
        });
    });

});





// * * * * * * * * * * * * * * * * * * * * * * * * *
// * table router (switch tables)
// *
// *
$(window).on("hashchange", function (e) {
    // optional: prevent default browser scroll on hash change
    if (e.type === "hashchange") {
        // Scroll zurück auf die aktuelle Position
        var scrollV = $(window).scrollTop();
        var scrollH = $(window).scrollLeft();
        $(window).scrollTop(scrollV).scrollLeft(scrollH);
    }

    // show all hidden cells
    $(".js-table-row").show();

    // reset hidden filters
    $(".js-samsrisk-field").html('-');

    var hash = window.location.hash.substring(1); // entfernt das führende #

    // change table
    $('.js-tableswitcher-item[data-id="' + hash + '"]').addClass("active").siblings().removeClass("active");

    // set value to select
    var selectValue = (window.location.hash.length) ? $('a[href="' + window.location.hash + '"] > *').html() : 'Select Indication';
    $(".js-tableswitcher-field").html(selectValue);

    // set value to statins select
    var selectValue = (window.location.hash.length) ? $(".js-dropdown-statin").find('a[href="' + window.location.hash + '"] > *').html() : '-';
    $(".js-statinswitcher-field").html(selectValue);
    //$(".js-dropdown-statin").find("a:first").trigger("click");

    // limit dropdowns to available filter options
    $(".js-dropdown-option").each(function () {
        var value = $(this).val(),
            filter = $(this).data("filter");

        if (filter == 'gene') {
            if ($(`.active .js-filter-${filter}-${value}`).length === 0) {
                $(this).prop('checked', false).trigger("change").parent().addClass("hidden");
            } else {
                $(this).prop('checked', false).trigger("change").parent().removeClass("hidden");
            }
        }
    });

    // hide unused dropdowns
    $(".js-dropdown-wrapper").addClass("hidden");
    $(".js-dropdown-tableswitcher").removeClass("hidden");

    if (hash.toLowerCase().includes("antidepressants")) {
        $(".js-dropdown-genes").removeClass("hidden");
    }
    if (hash.toLowerCase().includes("analgesics")) {
        $(".js-dropdown-genes").removeClass("hidden");
    }
    if (hash.toLowerCase().includes("anti-psychotics")) {
        $(".js-dropdown-genes").removeClass("hidden");
    }
    if (hash.toLowerCase().includes("inhibitors-and")) {
        $(".js-dropdown-inhibitor").removeClass("hidden");
    }
    if (hash.toLowerCase().includes("proton-pump")) {

    }
    if (hash.toLowerCase().includes("statins")) {
        $(".js-dropdown-statin").removeClass("hidden");
        $(".js-dropdown-samsrisk").removeClass("hidden");
    }
    if (hash.toLowerCase().includes("statins-default")) {
        $(".js-dropdown-samsrisk").addClass("hidden");
    }

    // reset all selection of dropdowns
    $(".js-dropdown-selected-option.active").trigger("click");

    // reset statins table switcher
    if (hash === 'statins-default') $(".js-dropdown-statin .js-tableswitcher-link:first").addClass("active").siblings().removeClass("active");



    // mark links active
    // $(".js-dropdown-wrapper").each(function(){
    //     $(this).find('a[href="#' + hash + '"]').addClass("active");
    // });



});

$(window).on("load", function (e) {
    // trigger first item
    var hash = $(".js-tableswitcher-link").eq(0).attr("href");
    if (hash) {
        hash = hash.split('#')[1];
        window.location.hash = hash;
        $(window).trigger("hashchange");
    }


});

// * * * * * * * * * * * * * * * * * * * * * * * * *
// * scrolling table styling and cell height and table header height
// *
// *
function checkTableScrolling() {
    $(".js-table").each(function () {
        let $this = $(this);

        // scrolling bars
        if (this.scrollWidth > $(".js-table-wrapper").innerWidth()) {
            $(this).parents(".js-table-wrapper").addClass("is-scrollable");
        } else {
            $(this).parents(".js-table-wrapper").removeClass("is-scrollable");
        }


        // cell height

        // Reset inline height for rows
        $(this).find(".js-table-row").css("height", "");

        var cellHeight = 1;
        $(this).find(".js-table-row").each(function () {
            var height = $(this).outerHeight();
            if (height >= cellHeight) cellHeight = height;
        });

        $(this).find(".js-table-row").css("height", cellHeight + 'px');

        // Header height

        // Reset inline height for headers
        $(this).find(".js-table-header").css("height", "");

        var tabelHeaderHeight = 1;
        $(this).find(".js-table-header").each(function () {
            var height = $(this).outerHeight();
            if (height >= tabelHeaderHeight) tabelHeaderHeight = height;
        });

        $(this).find(".js-table-header").css("height", tabelHeaderHeight + 'px');
    });
}

$(window).on("load resize", checkTableScrolling);